<template>
  <div v-if="products && products.length > 0" class="layout-container px-0 md:px-56">
    <div class="text-xsmall-medium sm:text-small-medium mb-12 sm:mb-24 px-24 md:px-0">
      {{ productResources.similarProducts }}
    </div>
    <div class="mb-48 md:mb-80">
      <client-only>
        <swiper
          :modules="[SwiperFreeMode]"
          :free-mode="true"
          :space-between="isMobile ? 8 : 24"
          :slides-per-view="isMobile ? 3.2 : 4"
          :threshold="30"
          class="product-listing-swiper mobileOnly:!px-24"
        >
          <swiper-slide
            v-for="(product, index) in products"
            :key="index"
            class="!h-auto"
          >
            <ProductSpot
              v-if="product"
              :product="product"
              :show-excerpt="false"
              :show-quickbuy="false"
              :small-layout="false"
              :slim-layout="isMobile ? true : false"
              :large="false"
            />
          </swiper-slide>
        </swiper>
      </client-only>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useUiStore } from '~/store/ui';
import { storeToRefs } from 'pinia';
import { useGlobalContentStore } from '~/store/globalContent';
import ProductSpot from '~/components/product/ProductSpot.vue';
import { type IProduct } from '~/api-types';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { FreeMode } from 'swiper/modules';
import 'swiper/css';
const productResources = useGlobalContentStore().productResources;
const { isMobile } = storeToRefs(useUiStore());

defineProps<{
  products: IProduct[],
}>();

</script>
